define([
    'ko',
    'jquery',
    'matchSize',
    'slick',
], (ko, $, matchSize) => {
    const defaultSpeed = 7000;

    return {
        init(options, element) {
            this.initCache(options, element);
            this.initEvents();
            this.initSlider();
        },

        initCache(options, element) {
            this.options = options;
            this.$banner = $(element);
            this.$bannerContainer = this.$banner.parents();
            this.$lastGroupPreviewId = -1;
            this.$bannerPreviewItem = $('.js-banner-preview-item');
            this.$bannerPreviewStreakSelector = '.home-banner-preview__streak';
        },

        initEvents() {
            this.$bannerPreviewItem.on('click', this.showBannerItem.bind(this));
            this.$bannerPreviewItem.on('click', this.pauseBannerItem.bind(this));
        },

        initSlider() {
            this.$bannerContainer.addClass('_ready-to-show');

            this.$banner.on('init', () => {
                const firstSlideIndex = $('div[data-slick-index="0"]');

                if (firstSlideIndex) {
                    this.checkImage(true);
                }

                this.setFirstActivePreviewItem();
                this.showGroupPreview(0);
                this.animatePreview(0);
            });

            this.$banner.slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: false,
                pauseOnHover: false,
                pauseOnFocus: false,
                arrows: (this.options.autoplay !== undefined) ? this.options.autoplay : false,
                autoplay: (this.options.autoplay !== undefined) ? this.options.autoplay : false,
                autoplaySpeed: this.options.autoplaySpeed || defaultSpeed,
                infinite: true,
                speed: 500,
                adaptiveHeight: true,
                responsive: [{
                    breakpoint: 768,
                    settings: {
                        fade: false,
                    },
                }],
            });

            if (!this.options.arrows) {
                this.$banner.find('.home-banner-arrow').each((i, el) => {
                    $(el).css('visibility', 'hidden');
                });
            }

            if (this.options.deferredAutoplay && matchSize().desktop) {
                this.$banner.slick('slickSetOption', 'autoplay', true, true);
            }

            this.$banner.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
                if (currentSlide === nextSlide) { return; }

                this.$bannerPreviewItem.removeClass('_active').eq(nextSlide).addClass('_active');
                this.$bannerContainer.removeClass('_ready-to-show');

                this.rollbackAnimatePreview(currentSlide);
                this.showGroupPreview(nextSlide);
                this.animatePreview(nextSlide);
                this.playSlick();
            });

            this.$banner.on('afterChange', () => this.checkImage());

            this.initSwipeLazyLoad(this.$banner);
        },

        animatePreview(number) {
            const $streak = $(this.$bannerPreviewItem[number])
                .find(this.$bannerPreviewStreakSelector);

            $streak.animate(
                {width: '100.5%'},
                this.options.autoplaySpeed,
                'linear'
            );
        },

        rollbackAnimatePreview(number) {
            const $streak = $(this.$bannerPreviewItem[number])
                .find(this.$bannerPreviewStreakSelector);

            $streak.stop().css('width', 0);
        },

        getGroupPreviewId(number) {
            return Number($(this.$bannerPreviewItem[number]).data('banner-group-id'));
        },

        getPreviews(groupId) {
            const $selector = `[data-banner-group-id='${groupId}']`;

            return $('.js-home-banner-preview-list').find($selector);
        },

        showGroupPreview(number) {
            if (matchSize().mobile) {
                return;
            }

            const $groupId = this.getGroupPreviewId(number);
            if ($groupId === this.$lastGroupPreviewId) {
                return;
            }

            const $curPreviews = this.getPreviews($groupId);
            const $lastPreviews = this.getPreviews(this.$lastGroupPreviewId);
            const $previewList = $('.js-home-banner-preview-list');

            $previewList.fadeOut(175);
            setTimeout(function () {
                $lastPreviews.each((i, el) => $(el).css('display', 'none'));
                $curPreviews.each((i, el) => $(el).css('display', 'inline-flex'));
            }, 175);
            $previewList.fadeIn(175);

            this.$lastGroupPreviewId = $groupId;
        },

        setFirstActivePreviewItem() {
            const $firstPreview = $(this.$bannerPreviewItem[0]);

            $firstPreview.addClass('_active');
        },

        checkImage(waitForLoad) {
            const $active = this.$banner.find('.slick-active');
            const delay = (this.options.autoplaySpeed || defaultSpeed) - 1000;
            const $nextItem = $active.next();

            if (this.options.deferredAutoplay) {
                this.loadImage($active, false, waitForLoad);

                setTimeout(() => {
                    this.loadImage($nextItem, true);
                }, delay);
            }
        },

        loadNextSliderImage() {
            const $active = this.$banner.find('.slick-active');

            this.loadImage($active.next(), true);
        },

        loadPrevSliderImage() {
            const $active = this.$banner.find('.slick-active');

            this.loadImage($active.prev(), true);
        },

        loadImage($slide, forceLoad, waitForLoad) {
            const $inner = $slide.find('.js-home-banner-image');

            $inner.each((i, el) => {
                const $item = $(el);
                const src = (matchSize().mobile) ? $item.attr('data-mobile-src') : (matchSize().desktopSmall || matchSize().tablet) ? $item.attr('data-tablet-src') : $item.attr('data-src');
                const isVisible = $item.is(':visible');
                const canLoad = src && (forceLoad || isVisible);

                if (!canLoad) { return; }

                if (!waitForLoad) {
                    this.setElementImage($item, src);

                    return;
                }

                const loader = new Image();

                loader.src = src;
                loader.addEventListener('load', () => {
                    this.setElementImage($item, src);
                });
            });
        },

        setElementImage($item, src) {
            $item.css('background-image', `url("${src}")`);
        },

        initSwipeLazyLoad($banner) {
            $banner.on('touchstart mousedown', () => {
                this.loadNextSliderImage();
                this.loadPrevSliderImage();
            });
        },

        pauseSlick() {
            this.$banner.slick('slickPause');
        },

        playSlick() {
            this.$banner.slick('slickPlay');
        },

        getBannerId(ev) {
            return Number($(ev.currentTarget).data('banner-preview-id'));
        },

        showBannerItem(ev) {
            this.$banner.slick('slickGoTo', this.getBannerId(ev), false);
        },

        pauseBannerItem(ev) {
            this.pauseSlick();
            this.rollbackAnimatePreview(this.getBannerId(ev));
        },
    };
});
